import { Box, CardContent, Divider } from "@mui/material";
import { AboutIcon, Card, Grid, Spacer, Typography } from "../style";
import {
  CalendarMonth,
  DirectionsCar,
  LocalShipping,
  Settings,
  TwoWheeler,
} from "@mui/icons-material";

function VeicoloCard({ veicolo }) {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Veicolo ({veicolo?.tipoVeicolo.value})
        </Typography>

        <Spacer mb={4} />

        <Grid container direction="row" alignItems="center" mb={2}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap="2"
          >
            {veicolo?.tipoVeicolo.value === "AUTOCARRO" ? (
              <AboutIcon>
                <LocalShipping />
              </AboutIcon>
            ) : veicolo?.tipoVeicolo.value === "MOTOCICLO" &&
              veicolo?.tipoVeicolo.value === "CICLOMOTORE" ? (
              <AboutIcon>
                <TwoWheeler />
              </AboutIcon>
            ) : (
              <AboutIcon>
                <DirectionsCar />
              </AboutIcon>
            )}
            {veicolo?.marca} {veicolo?.modello}
          </Box>
        </Grid>

        <Grid container direction="row" alignItems="center" mb={2}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap="2"
          >
            <AboutIcon>
              <Settings />
            </AboutIcon>
            {veicolo?.cilindrata} cc, {veicolo?.KW} Kw,{" "}
            {veicolo?.alimentazione.value}
          </Box>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap="2"
          >
            <AboutIcon>
              <CalendarMonth />
            </AboutIcon>
            Immatricolato il {veicolo?.Data_Immatricolazione}
          </Box>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap="2"
          >
            <AboutIcon>
              <CalendarMonth />
            </AboutIcon>
            Acquistato il {veicolo?.dataAcquisto}
          </Box>
        </Grid>
      </CardContent>
      <Divider />
    </Card>
  );
}

export default VeicoloCard;
